import {css} from '@emotion/css';
import {spacing} from '@fo/shared/styles/variables';

const styles = {
  homepageCheckpoints: css`
    label: homepageCheckpoints;
    margin-bottom: ${spacing.S};
  `,
};

export default styles;
